//Index Bnaner Slider
var indexbanSlider = document.querySelector(".index-banner-slider");
if (indexbanSlider) {
  const splide = new Splide(indexbanSlider, {
    type: 'loop',
    speed: 1500,
    perPage: 1,
    perMove: 1,
    gap: '0rem',
    autoplay: false,
    pagination: true,
    arrows: false,
    autoScroll: false, 
    breakpoints: {
    },
  });
  splide.on('mounted', () => {
    if (indexbanSlider.querySelector('.splide__arrows')) {
      indexbanSlider.classList.add('has-arrows');
    }
  });
   splide.mount(window.splide.Extensions);
}


//Real Satisfaction Slider
var realsatisfactionSlider = document.querySelector(".real-satisfaction-slider");
if (realsatisfactionSlider) {
  const splide = new Splide(realsatisfactionSlider, {
    type: 'slide',
    speed: 800,
    perPage: 3,
    perMove: 1,
    gap: '2.9rem',
    autoplay: false,
    pagination: false,
    arrows: true,
    autoScroll: false, 
    breakpoints: {
      989: {
			perPage: 2,
      gap: '1.5rem',
      pagination: true,
		},
    767: {
			perPage: 1,
      gap: '1.0rem',
      padding: {
        left: '0rem',
        right: '5rem',
      }
		},
    },
  });
  splide.on('mounted', () => {
    if (realsatisfactionSlider.querySelector('.splide__arrows')) {
      realsatisfactionSlider.classList.add('has-arrows');
    }
  });
   splide.mount(window.splide.Extensions);
}

//Real Satisfaction Slider
var featureblogSlider = document.querySelector(".index-feature-blog");
if (featureblogSlider) {
  const splide = new Splide(featureblogSlider, {
    type: 'slide',
    speed: 800,
    perPage: 3,
    perMove: 1,
    gap: '3.0rem',
    autoplay: false,
    pagination: false,
    arrows: true,
    autoScroll: false, 
    breakpoints: {
      989: {
			perPage: 2,
      gap: '1.5rem',
      pagination: true,
		},
    767: {
			perPage: 1,
      gap: '1.0rem',
		},
    },
  });
  splide.on('mounted', () => {
    if (featureblogSlider.querySelector('.splide__arrows')) {
      featureblogSlider.classList.add('has-arrows');
    }
  });
   splide.mount(window.splide.Extensions);
}

var pdpSlider = document.querySelector(".prd-slider");
if (pdpSlider) {
  const splide = new Splide(pdpSlider, {
    type: 'slide',
    speed: 800,
    perPage: 3,
    perMove: 1,
    gap: '3.0rem',
    autoplay: false,
    pagination: false,
    arrows: true,
    autoScroll: false, 
    breakpoints: {
      989: {
			perPage: 2,
      gap: '1.5rem',
      pagination: true,
		},
    767: {
			perPage: 1,
      gap: '1.0rem',
		},
    },
  });
  splide.on('mounted', () => {
    if (pdpSlider.querySelector('.splide__arrows')) {
      pdpSlider.classList.add('has-arrows');
    }
  });
   splide.mount(window.splide.Extensions);
}




// FAQ 
const accordionHeaders = document.querySelectorAll('.faq-accordion-title');
accordionHeaders.forEach(header => {
  header.addEventListener('click', () => {
    const item = header.parentElement;
    const content = item.querySelector('.faq-accordion-content');
    document.querySelectorAll('.faq-accordion-item').forEach(i => {
      if (i !== item) {
        i.classList.remove('active');
        i.querySelector('.faq-accordion-content').style.maxHeight = null;
      }
    });
    if (item.classList.contains('active')) {
      item.classList.remove('active');
      content.style.maxHeight = null;
    } else {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

